import { archiveFilters } from "./triproutes-archive.mjs";
import { callMoney, callQuery } from "./product-calls.mjs";

export const metricsPeriods = [["7d", "Неделя"], ["30d", "Месяц"], ["all", "За всё время"]];
export const metricsLocationEvent = "triproutes-metrics-change";
const periods = ["24h", "7d", "30d", "90d", "all", "custom"];

export function metricsLocation(hash = globalThis.location?.hash || "") {
  const q = new URLSearchParams(hash.split("?")[1] || "");
  let tab = q.get("tab");
  if (!["overview", "calls", "cities"].includes(tab)) {
    // Existing links from results, charts and exports open the city history.
    tab = ["execution", "snapshotId", "source", "query", "outcome", "timezone", "from", "to", "fromDay", "toDay"].some(key => q.has(key)) || q.get("period") === "custom" ? "cities" : "overview";
  }
  return {
    tab,
    period: periods.includes(q.get("period")) ? q.get("period") : "30d",
    site: ["ru", "app"].includes(q.get("site")) ? q.get("site") : "",
    timezone: archiveFilters(hash).timezone,
  };
}

export function metricsOverviewHash(hash = globalThis.location?.hash || "") {
  const location = metricsLocation(hash);
  const period = metricsPeriods.some(([key]) => key === location.period) ? location.period : "30d";
  return metricsHash("overview", period, location.tab === "calls" ? "" : location.site);
}

export function metricsHash(tab, period, site = "") {
  const q = new URLSearchParams({ tab, period });
  if (site || tab === "cities") q.set("site", site || "ru");
  return `#/triproutes/metrics?${q}`;
}

export function replaceMetricsLocation(hash, push = false) {
  window.history[push ? "pushState" : "replaceState"](null, "", hash);
  window.dispatchEvent(new Event(metricsLocationEvent));
}

export function sameMetricsFilters(current, next) {
  return Object.keys(next).every(key => current[key] === next[key]);
}

export function metricsCallFilters(hash = globalThis.location?.hash || "") {
  const q = new URLSearchParams(hash.split("?")[1] || "");
  const location = metricsLocation(hash);
  return { agent: q.get("agent") || "", model: q.get("model") || "", site: location.site, period: location.period === "custom" ? "30d" : location.period };
}

export async function loadMetricsOverview(api, filters, signal, receive) {
  // The call card covers all sites, as the original call metrics did. The city
  // history has a separate site selection; returning from it must not silently
  // narrow the call card to RU or APP.
  const calls = callQuery({ period: filters.period, site: "" }); calls.set("view", "summary");
  const cities = new URLSearchParams({site:filters.site||"ru",period:filters.period});
  return Promise.all([
    ["calls", `/v1/products/triproutes/calls?${calls}`],
    ["cities", `/v1/triproutes/city-routes/metrics?${cities}`],
  ].map(async ([kind, url]) => {
    try {
      const data = await api.request(url, { signal });
      if (!signal.aborted) receive(kind, { data });
    } catch (error) {
      if (!signal.aborted) receive(kind, { error });
    }
  }));
}

export function metricsCardStats(kind, data, canViewFinance) {
  const totals = data.totals;
  const stats = kind === "calls" ? [
    ["Вызовы моделей", totals.calls], ["Успешные", totals.successful],
    ["В работе", totals.active], ["Ошибки / ответ не подтверждён", totals.errors],
  ] : [
    ["Запуски", totals.cities], ["Заказано маршрутов", totals.requested],
    ["Передано в модерацию", totals.delivered], ["Опубликовано", totals.published],
  ];
  if (canViewFinance && data.financeVisible === true) {
    const usd = kind === "calls" ? totals.costs?.find(cost => cost.currency === "USD") : totals.costGroups?.find(cost => cost.key === "total" && cost.currency === "USD");
    const known = usd?.amount != null;
    const value = known ? callMoney({ amount: usd.amount, currency: "USD", costStatus: "final" }).replace(" USD", "") : (kind === "calls" ? totals.calls : totals.cities) ? "Нет данных" : "—";
    const unknown = totals.unknownCosts || 0;
    stats.push(["Расходы на модели, USD", value, unknown ? `Учтено частично · ${unknown.toLocaleString("ru-RU")} без полной цены` : ""]);
  }
  return stats;
}
